import script from "./OfCampaigns.vue?vue&type=script&setup=true&lang=js"
export * from "./OfCampaigns.vue?vue&type=script&setup=true&lang=js"

import "./OfCampaigns.vue?vue&type=style&index=0&id=89dccf06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89dccf06"]])

export default __exports__